import {connect} from 'react-redux'
import SidebarReports from 'components/SidebarReports'
import {grossProfitPageRequest,
  changeDateGrossProfit,
  changeOutletGrossProfit,
  exportGrossProfit
} from 'actions/reports/sales'
import {currencyFormatter, rupiah} from 'utils/formatter'
import moment from 'moment'
import {formValueSelector} from 'redux-form'
import ActionBar from '../ActionBar'
import styles from './GrossProfit.css'
import LoadingSpinner from 'components/LoadingSpinner'
import {browserHistory} from 'react-router'
import WarningLabel from './WarningLabel'
import {OverlayTrigger, Popover} from 'react-bootstrap'
import * as mpGrossProfit from 'mixpanel/reports/grossProfit'
import InformationModal from './InformationModal'

class GrossProfit extends React.Component {
  componentDidMount () {
    const {expired} = this.props.data.subscriptionExpired
    const expireTime = 365
    if (!expired) {
      this.props.dispatch(grossProfitPageRequest())
      let statusLabelNew = Cookies.get('labelNew') === undefined || Cookies.get('labelNew') === 'true'
      statusLabelNew ? Cookies.set('labelNew', 'true', { path: '/', domain: '.mokapos.com', expires: expireTime }) : Cookies.set('labelNew', 'false', { path: '/', domain: '.mokapos.com', expires: expireTime })
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  constructor (props) {
    super(props)
    this.state = {
      openSidebar: false,
      openInfoModal: false
    }
  }

  render () {
    let {showLoadingSpinnerReport} = this.props.data.reports.grossProfit
    return (
      <div id='reports-sales-gross-profit' className={styles.wrapper}>
        <ActionBar onChangeDate={this._onChangeDate} onChangeOutlet={this._onChangeOutlet} onExport={this._onClickExport} />
        <div className='mk-report-sales full-height'>
          <div className='row full-height'>
            <SidebarReports elementClass='visible-lg visible-md slideMenuWeb' location={this.props.location} />
            <SidebarReports elementClass={'visible-xs visible-sm slideMenuMobile ' + (this.state.openSidebar ? 'slideMenuMobileSlide' : '')} onToggle={this._toogleSidebar} location={this.props.location} />
            <div className='col-xs-12 col-sm-12 col-md-9 col-lg-9 report-right-menu full-height'>
              <div className='mk-report-sales-content full-height'>
                <div className='mk-burger-box visible-xs visible-sm'>
                  <div className='mk-burger'>
                    <button type='button' className='navbar-toggle collapsed navbar-burger' onClick={this._showSidebar} data-toggle='collapse' >
                      <span className='sr-only'>Toggle navigation</span>
                      <span className='icon-bar' />
                      <span className='icon-bar' />
                      <span className='icon-bar' />
                    </button>
                  </div>
                </div>
                <div className={`${styles['table-wrapper-responsive']} visible-xs visible-sm`}>
                  <LoadingSpinner showLoadingSpinner={showLoadingSpinnerReport} />
                  {showLoadingSpinnerReport !== undefined && !showLoadingSpinnerReport && <div className={`${styles.header_panel} panel panel-default`}>
                    <div className='panel-body'>
                      <h5 className={`${styles.thickTitle}`}>Gross Profit</h5>
                      <p>Gross Profit is your Net Sales minus Cost of Goods Sold (COGS). <strong>To report gross profit accurately, please make sure all items have a COGS.</strong></p>
                    </div>
                  </div>}
                  {showLoadingSpinnerReport !== undefined && !showLoadingSpinnerReport && this._renderTable()}
                </div>
                <div className={`${styles['table-wrapper']} visible-md visible-lg`}>
                  <LoadingSpinner showLoadingSpinner={showLoadingSpinnerReport} />
                  <div className={`${styles.header_panel} panel panel-default`}>
                    <div className='panel-body'>
                      <h5 className={`${styles.thickTitle}`}>Gross Profit</h5>
                      <p>Gross Profit is your Net Sales minus Cost of Goods Sold (COGS). <strong>To report gross profit accurately, please make sure all items have a COGS.</strong></p>
                    </div>
                  </div>
                  { !showLoadingSpinnerReport && this._renderTable()}
                </div>
              </div>
            </div>
          </div>
        </div>
        <InformationModal onShow={this.state.openInfoModal} click={this._onClickInfoButtonHideModal} />
      </div>
    )
  }

  _onChangeOutlet = (outletIds = []) => {
    let {startDate, endDate} = this.props.search.date
    mpGrossProfit.reportGrossProfitChangeFilter({outletIds, startDate, endDate})
    this.props.dispatch(changeOutletGrossProfit({outletIds, startDate, endDate}))
  }

  _showSidebar = () => {
    this.setState({openSidebar: !this.state.openSidebar})
  }

  _toogleSidebar = () => {
    this.setState({openSidebar: !this.state.openSidebar})
  }

  _onChangeDate = ({startDate, endDate}) => {
    const {outlet} = this.props.search
    mpGrossProfit.reportGrossProfitChangeFilter({outletIds: outlet, startDate, endDate})
    this.props.dispatch(changeDateGrossProfit(startDate.toDate(), endDate.toDate()))
  }

  _onClickExport = () => {
    let {startDate, endDate} = this.props.search.date
    const outlet = this.props.search.outlet

    let query = {start: moment(startDate).format('D/M/Y'), end: moment(endDate).format('D/M/Y')}
    let dateLabel = startDate.isSame(endDate, 'days') ? moment(startDate).format('DD-MM-YYYY') : [moment(startDate).format('DD-MM-YYYY'), moment(endDate).format('DD-MM-YYYY')].join(' - ')
    let filename = 'Report Gross Profit - ' + dateLabel
    this.props.dispatch(exportGrossProfit(query, filename, outlet[0]))
  }

  _renderTable = () => {
    const {gross_profit} = this.props.data.reports.grossProfit
    let cogsAdjusmentInfo = gross_profit.cogs_adjusment === 0
    let marginInfo = gross_profit.cogs !== 0 && gross_profit.net_sales > 0
    let cogsPercent = Math.round((gross_profit.cogs / gross_profit.net_sales) * 100)
    let grossProfPercent = Math.round((gross_profit.gross_profit / gross_profit.net_sales) * 100)
    let cogsAdjusmentPercent = Math.round((gross_profit.cogs_adjusment / gross_profit.net_sales) * 100)

    const discount = this._getDiscount()
    const popover = (<Popover>
      <p className={styles['tooltip-message']}>
        COGS adjustment happens when you create a Purchase Order, Refund or have an Incoming Transfer for an item that previously had negative inventory.
      </p>
    </Popover>)
    return <table className='table table-responsive mk-table-summary no-margin'>
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Gross Sales</td>
          <td className={`text-right text-unimportant`}>
            {currencyFormatter(gross_profit.gross_sales)}
            {marginInfo && <span className={`${styles.precent_label_none} label label-success hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block`} />}
          </td>
        </tr>
        <tr>
          <td>Discounts</td>
          <td className={`text-right text-unimportant`}>
            {discount === 0 ? currencyFormatter(discount) : `(` + currencyFormatter(discount) + `)`}
            {marginInfo && <span className={`${styles.precent_label_none} label label-success hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block`} />}
          </td>
        </tr>
        <tr>
          <td>Refunds</td>
          <td className={`text-right text-unimportant`}>
            { currencyFormatter(-gross_profit.refund) }
            {marginInfo && <span className={`${styles.precent_label_none} label label-success hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block`} />}
          </td>
        </tr>
        <tr className='divider'>
          <td><strong>Net Sales</strong></td>
          <td className={`text-right`}>
            <strong>{ currencyFormatter(gross_profit.net_sales) }</strong>
            { marginInfo &&
            <span className={gross_profit.net_sales < 0
              ? `${styles.precent_label_danger} label label-success hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block`
              : `${styles.precent_label} label label-success hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block`}>
              { '100%'}
            </span>
            }
          </td>
        </tr>
        <tr>
          <td>
            <span className='hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block'>Cost of Goods Sold (COGS)</span>
            <span className='visible-xs-inline-block visible-sm-inline-block hidden-md-down hidden-lg-down'>COGS</span>
          </td>
          <td className={`text-right text-unimportant`}>
            { gross_profit.cogs > 0 && gross_profit.cogs !== 0 ? currencyFormatter(-gross_profit.cogs) : rupiah(Math.abs(gross_profit.cogs)) }
            { marginInfo &&
              <span className={gross_profit.cogs >= 0
                ? `${styles.precent_label_danger} label label-success hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block`
                : `${styles.precent_label} label label-success hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block`}>
                  {!isNaN(cogsPercent) ? cogsPercent + '%' : '0%'}
              </span>
            }

          </td>
        </tr>
        { !cogsAdjusmentInfo &&
          <tr>
            <td>
              <span className='hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block'>Cost of Goods Sold (COGS) Adjustment</span>
              <span className='visible-xs-inline-block visible-sm-inline-block hidden-md-down hidden-lg-down'>COGS Adjustment</span>
              <div className='visible-md-inline-block visible-lg-inline-block hidden-sm-down'>
                <OverlayTrigger trigger={['click', 'hover', 'focus']} rootClose placement='top' overlay={popover}>
                  <button className={`${styles.btn_warning} hidden-xs-down visible-sm-inline-block visible-md-inline-block visible-lg-inline-block`} onMouseEnter={this._onMouseEnterCOGSAdjInfo}><WarningLabel /></button>
                </OverlayTrigger>
              </div>
              <div className='visible-xs-inline-block visible-sm-inline-block hidden-md-down hidden-lg-down'>
                <button className={`${styles.btn_warning}`} onClick={this._onClickInfoButton}><WarningLabel /></button>
              </div>
            </td>
            <td className={`text-right text-unimportant`}>
              { gross_profit.cogs_adjusment > 0 && gross_profit.cogs_adjusment !== 0 ? currencyFormatter(-gross_profit.cogs_adjusment) : rupiah(Math.abs(gross_profit.cogs_adjusment)) }
              { marginInfo &&
                <span className={gross_profit.cogs_adjusment >= 0
                  ? `${styles.precent_label_danger} label label-success hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block`
                  : `${styles.precent_label} label label-success hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block`}>
                    {!isNaN(cogsAdjusmentPercent) ? Math.abs(cogsAdjusmentPercent) + '%' : '0%'}
                </span>
              }
            </td>
          </tr>
        }
      </tbody>
      <tfoot>
        <tr className='text-total'>
          <td><strong>Gross Profit</strong></td>
          <td className={`text-right`}>
            <strong>{ currencyFormatter(gross_profit.gross_profit) }</strong>
            { marginInfo &&
              <span className={gross_profit.gross_profit < 0
                ? `${styles.precent_label_danger} label label-success hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block`
                : `${styles.precent_label} label label-success hidden-xs-down hidden-sm-down visible-md-inline-block visible-lg-inline-block`}>
                  {!isNaN(grossProfPercent) ? grossProfPercent + '%' : '0%'}
              </span>
            }
          </td>
        </tr>
      </tfoot>
    </table>
  }

  _onMouseEnterCOGSAdjInfo = () => {
    mpGrossProfit.reportGrossProfitHoverCOGSAdj()
  }

  _onClickInfoButton = () => {
    this.setState({openInfoModal: true})
  }

  _onClickInfoButtonHideModal = () => {
    this.setState({openInfoModal: false})
  }

  _getDiscount = () => {
    const {gross_profit} = this.props.data.reports.grossProfit
    return gross_profit.discount + gross_profit.redemption
  }
}

const selector = formValueSelector('search')

function select (state) {
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    data: {
      reports: {
        grossProfit: state.reports.grossProfit
      },
      subscriptionExpired: state.subscriptionExpired
    }
  }
}
export default connect(select)(GrossProfit)



// WEBPACK FOOTER //
// ./app/pages/Reports/Sales/GrossProfit/GrossProfit.js